import groq from 'groq'

import { frameBuilderImageFragment } from './image'

const frameBuilderPassepartoutColorFragment = groq`
  _id,
  sku,
  title,
  subtitle,
  description,
  color {
    hex,
  },
  coreColor {
    hex,
  },
  thumbnailImage {
    ${frameBuilderImageFragment}
  },
  "mouldingIds": availableFor[]._ref,
  thickness,
  price,
  minimumPrice,
  discountPercent,
  maximumWidth,
  maximumHeight,
`

const frameBuilderProductPassepartoutColorFragment = groq`
  _id,
  sku,
  title,
  "mouldingIds": availableFor[]._ref,
  price,
  minimumPrice,
  discountPercent,
  maximumWidth,
  maximumHeight,
`

export const frameBuilderPassepartoutColorObjectFragment = groq`
  "passepartoutColors": *[
    _type == "frameBuilderPassepartoutColor" &&
    locale == $locale
  ]
    | order(order asc)
  {
    ${frameBuilderPassepartoutColorFragment}
  },
`

export const frameBuilderProductPassepartoutColorObjectFragment = groq`
  "passepartoutColors": *[
    _type == "frameBuilderPassepartoutColor" &&
    locale == $locale
  ]
    | order(order asc)
  {
    ${frameBuilderProductPassepartoutColorFragment}
  },
`
